module.exports = __webpack_public_path__ + "img/photo-print.3e219915.jpg";